import React, { useState, useEffect, useCallback } from 'react';
import { metricsService } from '../../services/metricsService';

const fmt = (n, decimals = 1) =>
  typeof n === 'number' ? n.toFixed(decimals) : '—';

// Токен сюда больше не передаётся: он учётные данные входа, и в ответе
// /users его нет (решение владельца 09.09.2026). Задачи ищутся по email —
// ручка /users/{user_email}/tasks сама фильтрует сначала по нему.
const UserTasksDialog = ({ email, onClose }) => {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const PAGE_SIZE = 20;

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      if (!email) {
        // Строка журнала без адреса: раньше её задачи доставались по токену.
        // Молчаливый пустой список читался бы как «задач нет».
        setData({ tasks: [], total_count: 0, page: 1, page_size: PAGE_SIZE });
        setError('У этой строки нет адреса в журнале — задачи по ней не показать');
        return;
      }
      const result = await metricsService.getUserTasks(email, { page, page_size: PAGE_SIZE });
      setData(result);
    } catch (e) {
      setError('Ошибка загрузки задач');
    } finally {
      setLoading(false);
    }
  }, [email, page]);

  useEffect(() => {
    load();
  }, [load]);

  const totalPages = data ? Math.ceil(data.total_count / PAGE_SIZE) : 0;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="flex max-h-[90vh] w-full max-w-4xl flex-col rounded-[20px] bg-paper-card shadow-[0_24px_64px_rgba(0,0,0,.18)]">
        <div className="flex items-center justify-between border-b border-paper-line px-6 py-4">
          <div>
            <div className="font-semibold text-paper-ink">{email}</div>
            {data && (
              <div className="text-[13px] text-paper-ink-3">
                Задач: {data.total_count}
              </div>
            )}
          </div>
          <button
            className="text-[20px] leading-none text-paper-ink-3 hover:text-paper-ink"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="flex-1 overflow-auto px-6 py-4">
          {loading && <div className="py-8 text-center text-paper-ink-3">Загружаем…</div>}
          {error && <div className="py-8 text-center text-paper-accent">{error}</div>}
          {!loading && data && data.tasks.length === 0 && (
            <div className="py-8 text-center text-paper-ink-3">Задачи не найдены</div>
          )}
          {!loading && data && data.tasks.length > 0 && (
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-paper-line text-left font-mono text-[11px] uppercase tracking-[0.06em] text-paper-ink-3">
                  <th className="pb-2 pr-4 font-medium">Дата</th>
                  <th className="pb-2 pr-4 font-medium">Сервис</th>
                  <th className="pb-2 pr-4 font-medium">Файл / Модель</th>
                  <th className="pb-2 pr-4 font-medium text-right">Вход</th>
                  <th className="pb-2 pr-4 font-medium text-right">Время</th>
                  <th className="pb-2 pr-4 font-medium text-right">Ожидание</th>
                  <th className="pb-2 font-medium text-right">Выход</th>
                </tr>
              </thead>
              <tbody>
                {data.tasks.map((task) => {
                  const isSummarize = task.service === 'bit-llm-summarize';
                  return (
                  <tr key={task.task_id} className="border-b border-paper-line hover:bg-paper-panel">
                    <td className="whitespace-nowrap py-2 pr-4 text-paper-ink-2">
                      {new Date(task.timestamp?.endsWith?.('Z') || task.timestamp?.includes?.('+') ? task.timestamp : task.timestamp + 'Z').toLocaleString('ru-RU', {
                        month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
                      })}
                    </td>
                    <td className="py-2 pr-4 font-mono text-[12px] text-paper-ink-2">{task.service}</td>
                    <td className="max-w-[160px] truncate py-2 pr-4 text-paper-ink-2" title={isSummarize ? task.model : task.file_name}>
                      {isSummarize ? (task.model || '—') : (task.file_name || '—')}
                    </td>
                    <td className="py-2 pr-4 text-right font-mono text-[12px] text-paper-ink">
                      {isSummarize
                        ? (task.input_text_length ? task.input_text_length.toLocaleString('ru-RU') + ' сим' : '—')
                        : fmt(task.audio_seconds / 60) + ' мин'}
                    </td>
                    <td className="py-2 pr-4 text-right font-mono text-[12px] text-paper-ink">
                      {isSummarize
                        ? (task.time_summarize ? fmt(task.time_summarize) + ' с' : '—')
                        : fmt(task.transcribe_minutes) + ' мин'}
                    </td>
                    <td className="py-2 pr-4 text-right font-mono text-[12px] text-paper-ink">
                      {isSummarize ? '—' : fmt(task.wall_minutes) + ' мин'}
                    </td>
                    <td className="py-2 text-right font-mono text-[12px] text-paper-ink">
                      {isSummarize
                        ? (task.output_text_length ? task.output_text_length.toLocaleString('ru-RU') + ' сим' : '—')
                        : (task.symbols_count ? task.symbols_count.toLocaleString('ru-RU') + ' сим' : '—')}
                    </td>
                  </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {totalPages > 1 && (
          <div className="flex items-center justify-end gap-2 border-t border-paper-line px-6 py-4 text-[13px] text-paper-ink-3">
            <button
              className="rounded-chip bg-paper-bg px-3 py-1 text-paper-ink hover:bg-paper-panel disabled:text-paper-hint"
              onClick={() => setPage((p) => p - 1)}
              disabled={page === 1 || loading}
            >
              ←
            </button>
            <span className="text-[13px] text-paper-ink-3">
              {page} / {totalPages}
            </span>
            <button
              className="rounded-chip bg-paper-bg px-3 py-1 text-paper-ink hover:bg-paper-panel disabled:text-paper-hint"
              onClick={() => setPage((p) => p + 1)}
              disabled={page === totalPages || loading}
            >
              →
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserTasksDialog;
